<template>
    <div class="body_dom">
        <div class="image-dom">
            <!-- <div class="image-dom-one">
                <h3 class="dayimage-title">最近30天备案总数</h3>
                <div class="image-dom-div" style="height:320px" id="image1"></div>
            </div>

            <div class="image-dom-one">
                <h3 class="dayimage-title">企业和个人对比</h3>
                <div class="image-dom-div" style="height:360px" id="image2"></div>
            </div> -->

            <!-- <div class="image-dom-one">
                <h3 class="dayimage-title">全国备案大数据</h3>
                <div class="image-dom-div" style="height:800px" id="image3"></div>
            </div> -->
        </div>
    </div>
</template>
<script>
import * as ECharts from 'echarts';
import chinaMap from "@/assets/json/china.json";
export default {
    name:'vModularFive',
    data(){
        return{
            dataList:[],
            option_twe:null,
            option_one:null
        }
    },
    methods:{
        randomValue() {
            return Math.round(Math.random()*1000000);
        },
        imageOneFn(){
            var chartDom = document.getElementById('image1');
            var myChart = ECharts.init(chartDom);
            var option;
            option = this.option_one;
            option && myChart.setOption(option);
        },
        imageTweFn(){
            var chartDom = document.getElementById('image2');
            var myChart = ECharts.init(chartDom);
            var option;
            option = this.option_twe;
            option && myChart.setOption(option);
        },
        drawregionCharts () {
            let option = {
                backgroundColor: '#FFFFFF',
                title: {
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                visualMap:  {
                    show: true,
                    x: 'left',
                    y: 'top',
                    left:'2%',
                    top:'4%',
                    splitList: [
                        { start: 500000, end: 1000000 },
                        { start: 200000, end: 500000 },
                        { start: 50000, end: 200000 },
                        { start: 20000, end: 50000 },
                        { start: 5000, end: 20000 },
                        { start: 0, end: 5000 },
                    ],
                    color: ["#070093", "#1c3fbf", "#1482e5", "#70b4eb", "#b4e0f3", "#ffffff"]
                },
                //配置属性
                series: [{
                    name: '全国备案大数据',
                    type: 'map',
                    mapType: 'china',
                    zoom: 1.7,
                    top:'30%',
                    itemStyle: {
                        normal:{
                            borderColor: 'rgba(0, 0, 0, 0.2)'
                        },
                    },
                    roam: true,
                    showLegendSymbol: true,
                    label: {
                        normal: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    data: this.dataList
                }]
            }
            let mychart = ECharts.init(document.getElementById('image3'))
            mychart.setOption(option)
	    },
        initFun(){
            var _this = this;
            this.getRequest("api/clue/analysis",{}).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.dataList = [
                        {
                            name: "北京市",
                            value: data.obj.datas.count_bj
                        }, {
                            name: "天津市",
                            value: data.obj.datas.count_tj
                        }, {
                            name: "上海市",
                            value: data.obj.datas.count_sh
                        }, {
                            name: "重庆市",
                            value: data.obj.datas.count_cq
                        }, {
                            name: "河北省",
                            value: data.obj.datas.count_heb
                        }, {
                            name: "河南省",
                            value: data.obj.datas.count_hen
                        }, {
                            name: "云南省",
                            value: data.obj.datas.count_yn
                        }, {
                            name: "辽宁省",
                            value: data.obj.datas.count_ln
                        }, {
                            name: "黑龙江省",
                            value: data.obj.datas.count_hlj
                        }, {
                            name: "湖南省",
                            value: data.obj.datas.count_hun
                        }, {
                            name: "安徽省",
                            value: data.obj.datas.count_ah
                        }, {
                            name: "山东省",
                            value: data.obj.datas.count_sd
                        }, {
                            name: "新疆维吾尔自治区",
                            value: data.obj.datas.count_xj
                        }, {
                            name: "江苏省",
                            value: data.obj.datas.count_js
                        }, {
                            name: "浙江省",
                            value: data.obj.datas.count_zj
                        }, {
                            name: "江西省",
                            value: data.obj.datas.count_jx
                        }, {
                            name: "湖北省",
                            value: data.obj.datas.count_hub
                        }, {
                            name: "广西壮族自治区",
                            value: data.obj.datas.count_gx
                        }, {
                            name: "甘肃省",
                            value: data.obj.datas.count_gs
                        }, {
                            name: "山西省",
                            value: data.obj.datas.count_sx
                        }, {
                            name: "内蒙古自治区",
                            value: data.obj.datas.count_nmg
                        }, {
                            name: "陕西省",
                            value: data.obj.datas.count_shx
                        }, {
                            name: "吉林省",
                            value: data.obj.datas.count_jl
                        }, {
                            name: "福建省",
                            value: data.obj.datas.count_fj
                        }, {
                            name: "贵州省",
                            value: data.obj.datas.count_gz
                        }, {
                            name: "广东省",
                            value: data.obj.datas.count_gd
                        }, {
                            name: "青海省",
                            value: data.obj.datas.count_qh
                        }, {
                            name: "西藏自治区",
                            value: data.obj.datas.count_xz
                        }, {
                            name: "四川省",
                            value: data.obj.datas.count_sc
                        }, {
                            name: "宁夏回族自治区",
                            value: data.obj.datas.count_nx
                        }, {
                            name: "海南省",
                            value: data.obj.datas.count_han
                        }
                    ];
                    _this.option_twe = {
                        tooltip: {},
                        // legend: {
                        //     data: ['企业', '个人']
                        // },
                        color:['#53A8E2','#76DDFB'],
                        xAxis: {
                            data: data.obj.datas.days
                        },
                        grid:{
                            x:50,
                            y:50,
                            x2:50,
                            y2:50,
                            borderWidth:10
                        },
                        yAxis: {},
                        series: [
                            {
                                name: '企业',
                                type: 'bar',
                                barGap: 0,
                                data: data.obj.datas.counts_company
                            }, {
                                name: '个人',
                                type: 'bar',
                                data: data.obj.datas.counts_personal
                            }
                        ]
                    }
                    _this.option_one = {
                        tooltip: {},
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: data.obj.datas.days
                        },
                        grid:{
                            x:50,
                            y:50,
                            x2:50,
                            y2:50,
                            borderWidth:10
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                name: '备案总数',
                                data: data.obj.datas.counts,
                                type: 'line',
                                smooth: true,
                                areaStyle: {
                                    opacity:0.3,
                                    color:'#69B3E5' 
                                }, 
                                itemStyle : {  
                                    normal : {  
                                        lineStyle:{  
                                            color:'#69B3E5'  
                                        }  
                                    }  
                                } 
                            }
                        ]
                    };
                    _this.drawregionCharts();
                    _this.imageTweFn();
                    _this.imageOneFn();
                }
            })
        }
    },
    mounted(){
        ECharts.registerMap("china", { geoJSON: chinaMap });
        this.initFun();
    }
}
</script>
<style>
body{
    background-color: #F0F2F5;
}
</style>
<style lang="scss" scoped>
.body_dom{
    width: 100%;
    height: auto;
    background-color: #F0F2F5;
    >div.image-dom{
        height: auto;
        margin: 0 auto 0;
        @media screen and (max-width: 1400px){
            width: 960px;
        }
        @media screen and (min-width: 1400px){
            width: 1200px;
        }
        >div.image-dom-one{
            width: 100%;
            height: auto;
            margin-bottom: 40px;
            >h3.dayimage-title{
                width: 100%;
                height: auto;
                padding:20px;
                box-sizing: border-box;
                color: #333333;
                font-size: 18px;
                font-weight: bold;
                text-align: left;
                cursor: default;
                background-color: #fff;
            }
            >div.image-dom-div{
                width: 100%;
                height: auto;
                background-color: #fff;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/modular/modular_five.vue